export const ACCESS_TYPES = {
	RESTRICTED: 'RESTRICTED',
	PUBLIC: 'PUBLIC',
	ANONYMOUS: 'ANONYMOUS',
	INTERNAL: 'INTERNAL',
} as const;

export const PORTAL_ACCESS = ACCESS_TYPES;

export const SHARE_REQUESTS_ACCESS = {
	AGENT_ONLY: 'AGENT_ONLY',
	EMAIL_ONLY: 'EMAIL_ONLY',
	SEARCH_AUTO_COMPLETE: 'SEARCH_AUTO_COMPLETE',
} as const;

export type GlobalAccessTypeEnum =
	| typeof ACCESS_TYPES.PUBLIC
	| typeof ACCESS_TYPES.ANONYMOUS
	| typeof ACCESS_TYPES.INTERNAL;

export type PortalAcessEnum = keyof typeof PORTAL_ACCESS;

export type ShareRequestsAccessEnum = keyof typeof SHARE_REQUESTS_ACCESS;

export type SecuritySettings = {
	projectName: string;
	portalId: number;
	portalUrl: string;
	serviceDeskEmail: string;
	globalAccessType: GlobalAccessTypeEnum;
	portalAccess: PortalAcessEnum;
	shareRequestsAccess: ShareRequestsAccessEnum;
};

export type SecuritySettingsResponse = {
	autocompleteEnabled: boolean;
	canAdministerJIRA: boolean;
	customerRoleMisconfigured: boolean;
	emailAddress: string;
	globalAnonymousAccess: boolean;
	globalPublicSignup: boolean;
	manageEnabled: boolean;
	portalId: number;
	portalUrl: string;
	projectName: string;
	serviceDeskOpenAccess: boolean;
	serviceDeskPublicSignup: boolean;
};

export type RequestSecurityRequestBody = {
	autocompleteEnabled: boolean;
	manageEnabled: boolean;
	serviceDeskOpenAccess: boolean;
	serviceDeskPublicSignup: boolean;
};
